export const isLikelyNetworkError = (error) => {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;

  const code = String(error?.code || "").toLowerCase();
  const message = String(error?.message || "").toLowerCase();
  const status = Number(error?.status || error?.response?.status || 0);

  if (status === 0) return true;

  const codeSignals = [
    "err_network",
    "network_error",
    "network-request-failed",
    "unavailable",
    "deadline-exceeded",
  ];
  if (codeSignals.some((signal) => code.includes(signal))) return true;

  const messageSignals = [
    "failed to fetch",
    "network error",
    "network request failed",
    "internet connection",
    "offline",
    "load failed",
    "fetch failed",
    "timeout",
    "timed out",
  ];
  return messageSignals.some((signal) => message.includes(signal));
};

export const getFriendlyNetworkMessage = (fallbackMessage) => {
  const fallback = String(fallbackMessage || "").trim();
  return (
    "We couldn't reach the network right now. Please check your connection and try again. " +
    (fallback || "Your progress is still here.")
  );
};

export const mapToFriendlyNetworkError = (error, fallbackMessage) => {
  if (!isLikelyNetworkError(error)) return error;
  const friendly = new Error(getFriendlyNetworkMessage(fallbackMessage));
  friendly.code = error?.code || "network-unavailable";
  friendly.status = error?.status || error?.response?.status || 0;
  friendly.cause = error;
  return friendly;
};
